import { Button, List, message, Spin } from "antd";
import { useState, useEffect } from "react";
import { ComfirmButton } from "@/components";
import { useTranslation } from "react-i18next";
import { addOrgPermissions, removeOrgPermissions } from "@api";
import { USER_MANAG } from "@/enums/pageEnum";

export default function Permissions({
  userPermission,
  allPermissions,
  type,
  apiUrl,
  groupId,
}: {
  type?: string;
  apiUrl: string;
  groupId?: string;
  userPermission?: string[];
  allPermissions?: string[];
}) {
  const [defaMenus, setDefaMenus] = useState<string[]>([]);
  const [userMenus, setUserMenus] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (userPermission && allPermissions) {
      setLoading(false);
      setUserMenus(userPermission);
      const result = allPermissions.filter(
        (item) => !userPermission.includes(item)
      );
      setDefaMenus(result);
    }
  }, [userPermission, allPermissions]);

  const minusItem = (item: string, prve: string[]) => {
    const array: string[] = [];
    prve.map((ci) => {
      if (ci !== item) {
        array.push(ci);
      }
    });
    return array.sort();
  };

  const addPeriss = (permissions: string[], isAddAll?: boolean) => {
    setLoading(true);
    addOrgPermissions(apiUrl, { type, permissions, id: groupId })
      .then((res: any) => {
        setLoading(false);
        if (res.status === 200) {
          if (isAddAll) {
            setDefaMenus([]);
            setUserMenus([...defaMenus, ...userMenus]);
          } else {
            setUserMenus((prve) => [...prve, permissions[0]].sort());
            setDefaMenus((prve) => minusItem(permissions[0], prve));
          }
          message.success("Add success");
        }
      })
      .catch((err: any) => {
        setLoading(false);
        message.error(err);
      });
  };

  const removePeriss = (permissions: string[], isDelteAll?: boolean) => {
    setLoading(true);
    removeOrgPermissions(apiUrl, { type, permissions, id: groupId })
      .then((res: any) => {
        setLoading(false);
        if (res.status === 200) {
          if (isDelteAll) {
            setDefaMenus([...userMenus, ...defaMenus]);
            setUserMenus([]);
          } else {
            setDefaMenus((prve) => [...prve, permissions[0]].sort());
            setUserMenus((prve) => minusItem(permissions[0], prve));
          }
          message.success("Remove success");
        }
      })
      .catch((err: any) => {
        setLoading(false);
        message.error(err);
      });
  };

  return (
    <Spin tip="Loading..." spinning={loading}>
      <div className="flex justify-between bg-[#fff] dark:bg-[#141414] min-h-[calc(100vh-250px)] p-4">
        <div className="border-[#E0E0E0] dark:border-[#ffffff21] w-1/3 pr-5 border-r">
          <div className="flex justify-end items-center">
            <ComfirmButton
              onClick={() => {
                if (!defaMenus.length) return;
                addPeriss(defaMenus, true);
              }}
              buttonCogfig={{ disabled: !defaMenus.length }}
              popTitle={t("addAllPer")}
              description={t("hint.addAllTask")}
              title={t("addAll")}
            />
          </div>
          <List
            size="large"
            bordered
            className="mt-5"
            dataSource={defaMenus}
            renderItem={(item) => (
              <List.Item className="font-medium">
                <span>{t(item)}</span>
                <Button
                  color="primary"
                  variant="link"
                  className="pr-0"
                  onClick={() => addPeriss([item])}
                >
                  {t("add")}
                </Button>
              </List.Item>
            )}
          />
        </div>
        <div className="flex-1 pl-5 meBorder">
          <div className="flex justify-between items-center">
            <span>{t("hint.permisHint")}</span>
            <ComfirmButton
              onClick={() => {
                if (!userMenus.length) return;
                removePeriss(userMenus, true);
              }}
              buttonCogfig={{ disabled: !userMenus.length }}
              title={t("deleteAll")}
            />
          </div>
          <List
            size="large"
            bordered
            className="mt-5"
            dataSource={userMenus}
            renderItem={(item) => (
              <List.Item className="font-medium bg-[#F5F6F8] dark:bg-[#ffffff0b]">
                <span>{t(item)}</span>
                {item !== USER_MANAG && (
                  <ComfirmButton
                    onClick={() => removePeriss([item])}
                    title={t("remove")}
                    buttonCogfig={{
                      className: "pr-0",
                      variant: "link",
                    }}
                  />
                )}
              </List.Item>
            )}
          />
        </div>
      </div>
    </Spin>
  );
}
